import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    networkList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    height: {
      type: String,
      default: '435px'
    },
    top: {
      type: String,
      default: '0px'
    },
    defaultValue: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    },
    radioStatu: {
      type: Boolean,
      default: false
    },
    radioTop: {
      type: String,
      default: '22px'
    }
  },
  methods: {}
};